<template>
    <div>
        <div :class="['page loyalty',{ off: !pageOn }]">
            <VHeader type="back" @back="back" />
            <div class="page-content"> 
                    <div v-if="cameraId">
                        <div id="scan-box" style="width: 100%;float:left"></div>
                    </div>
                    <p v-if="cameraId" style="width: calc(100% - 10px);margin: 10px 5px 0px 5px;text-align: center;">{{ camera.label }}</p>
                    <p v-if="cameraId" class="btn" @click="changeCamera" style="margin-top: 20px;float: left;width: calc(100% - 80px);margin-left: 40px;">change camera</p>
                    <p v-if="!cameraId" v-for="camera in cameras" class="btn" style="line-height: 90px;margin: 40px 15px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" @click="startScan(camera)">{{ camera.label }}</p>
            </div>
        </div>
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { mapMutations } from 'vuex'
import { pageOn } from '@/utils/pageOn.js'
import Alert from '@/utils/Alert.js'
import WebSoc from '@/utils/WebSoc.js'
import Spinner from '@/components/Spinner.vue'

export default {
    name: 'scan',
    components: {
        VHeader,
        Spinner
    },
    mixins: [ pageOn ],
    computed: {
        auth () { return this.$store.state.auth },
        cameraId() { return this.$store.state.cameraId },
        cameras () { return this.$store.state.cameras },
        processedQuery () { return this.$store.state.processedQuery },
        camera () { return this.$store.state.camera }
    },
    data () {
        return {
            coupon: '',
            src: '',
            date: Date.now(),
            scanning: false,
            html5QrcodeScanner: false
        }
    },
    mounted () {
        if ( this.cameraId ) return this.startScan();
    },
    methods: {     
        changeCamera () {
            this.stopScanner();
            this.setValue({ k: 'cameraId', v: '' })
            this.setValue({ k: 'camera', v: false });
        },
        startScan ( camera ) {
            if ( camera ) this.setValue({ k: 'camera', v: camera });
            if ( camera ) this.setValue({ k: 'cameraId', v: camera.id });
            if ( camera ) { try { localStorage.cameraId = camera.id; } catch(e) {} }
            this.$nextTick(() => {
                this.html5QrcodeScanner = new Html5Qrcode('scan-box',{},false);
                this.html5QrcodeScanner.start(this.cameraId,{ fps: 10, qrbox: 250 },this.getScan,e  => {});
            });
        },
        getScan ( msg ) {
            var query = msg.split('?')[1];
                if ( !query ) return;
                query = query.split('&').reduce((prev,fields) => { var fields = fields.split('=');  prev[fields[0]] = fields[1]; return prev; } ,{});
                this.stopScanner();
                this.pageOn = false;
                this.$emit('scanned',query);
                return;       
        },
        back () {
            this.pageOn = false;
            this.stopScanner();
        },
        stopScanner () {
            this.html5QrcodeScanner && this.html5QrcodeScanner.stop().then(_ => { this.html5QrcodeScanner = false; }).catch(e => console.log('stop error',e));
        },
        ...mapMutations(['setValue','pushPage'])
    }
}
</script>

<style lang="scss">
.btn-item {
    margin-top:50px !important;
    justify-self: center;
    font-size:40px;
    text-align: center;
    line-height: 70px;
    width:70px;
    background-color:#f4bd00;
    color:#424B5A;
    border-radius: 50%;
    &:active { transform: translate(2px, 2px); }
}
</style>